import { style } from '@vanilla-extract/css';

export const container = style({
  paddingLeft: 'var(--wt-padding)',
  paddingRight: 'var(--wt-padding)',
  paddingTop: 'var(--wt-image-padding-top)',
  paddingBottom: 'var(--wt-image-padding-bottom)',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});

export const image = style({
  width: 'var(--image-width)',
});

export const imageLinkWrapper = style({
  textDecoration: 'none',
  width: 'var(--image-width)',
  margin: 'var(--image-alignment-margins)',
});

export const sponsorText = style({
  color:
    'var(--post-section-text-color, var(--site-theme-text-on-background-color, var(--wt-paragraph-color, #000000))) !important',
  fontSize: 'var(--wt-paragraph-font-size, 16px)',
  display: 'block',
  width: '300px',
  opacity: '0.8',
  margin: 'var(--image-alignment-margins)',
});
